import routeNames from '../../router/route-names';
import _get from 'lodash/get';
import {
  DEFAULT_CALCULATOR_CUSTOMER_OPTIONS,
  NEW_USED_LIST,
  QUOTE_STATUSES
} from '@/utils/constants';
import store from '@/store';

/**
 * Validations for each page which return true if they pass.
 */
export default {
  // As all inputs are defaulted, we will pass this if any input is different and all fields are on the application
  // Pass if there is a quote created as you can not edit a quote
  // Pass if a quote has been accepted as no quotes can be created edited after acceptance
  [routeNames.calculator]: ({ application = {} }) => {
    if (!store.getters['user/hasAccessAfterCalculator']) {
      return false;
    }

    if (store.getters['application/isQuoteAcceptedOrOpen']) {
      return true;
    }

    const requiredFields = ['carValue', 'leaseTerm', 'bodyType'];
    const customerOptions = _get(application, 'metaData.customerOptions') || {};
    if (
      JSON.stringify(customerOptions) ===
      JSON.stringify(DEFAULT_CALCULATOR_CUSTOMER_OPTIONS)
    ) {
      return false;
    }
    for (let i = 0; i < requiredFields.length; i++) {
      let key = requiredFields[i];
      if (!customerOptions[key]) {
        return false;
      }
    }

    return Boolean(application.applicationId);
  },
  // Pass if an application has been started. Since there are no inputs on this
  // page, if the calculator has passed then this should automatically pass
  [routeNames.budget]: ({ application = {} }) => {
    return Boolean(application.applicationId);
  },
  // Pass if all required fields have a value
  [routeNames.carSearch]: ({ carSearch = {} }) => {
    if (store.getters['application/isQuoteAcceptedOrOpen']) {
      return true;
    }

    const requiredFields = ['newUsed', 'makeId', 'modelId', 'year'];
    for (let i = 0; i < requiredFields.length; i++) {
      let key = requiredFields[i];
      if (!carSearch[key]) {
        return false;
      }
    }
    return true;
  },
  // Pass if there is a variant selected and the vehicle selection is new
  // Pass if there is a quote created as you can not edit a quote
  // Pass if a quote has been accepted as no quotes can be created edited after acceptance
  [routeNames.carSearchVariant]: ({ application = {} }) => {
    if (store.getters['application/isQuoteAcceptedOrOpen']) {
      return true;
    }

    const customerOptions = _get(application, 'metaData.customerOptions') || {};

    return (
      customerOptions.vehicleCondition === NEW_USED_LIST.new.value &&
      customerOptions.variant
    );
  },
  // Pass if there is no uploaded quote
  // Pass if there is a quote created as you can not edit a quote
  // Pass if a quote has been accepted as no quotes can be created edited after acceptance
  [routeNames.quoteUpload]: ({ application = {} }) => {
    if (store.getters['application/isQuoteAcceptedOrOpen']) {
      return true;
    }

    const quoteUpload = _get(application, 'metaData.quoteUpload') || {};
    return !quoteUpload.quoteFile;
  },
  // Pass if the selected variant is used (used variants can not go to this page)
  // Pass if there is a quote created as you can not edit a quote (at the end of this page a quote will be created)
  // Pass if a quote has been accepted as no quotes can be created edited after acceptance
  [routeNames.carColourAndExtras]: ({ application = {} }) => {
    if (store.getters['application/isQuoteAcceptedOrOpen']) {
      return true;
    }

    const customerOptions = _get(application, 'metaData.customerOptions') || {};
    return customerOptions.vehicleCondition === NEW_USED_LIST.used.value;
  },
  // Pass if the quote status is not draft, requested, submitted or awaiting pricing
  [routeNames.dealerPrice]: ({ quote = {} }) => {
    return (
      quote.status &&
      quote.status !== QUOTE_STATUSES.DRAFT.value &&
      quote.status !== QUOTE_STATUSES.REQUESTED.value &&
      quote.status !== QUOTE_STATUSES.SUBMITTED.value &&
      quote.status !== QUOTE_STATUSES.AWAITINGPRICING.value
    );
  },
  // Pass if there is an accepted quote on the application and a complete credit check
  [routeNames.summary]: () => {
    return (
      store.getters['application/isQuoteAccepted'] &&
      store.getters['application/isCreditCheckCompleted']
    );
  },
  // Pass if a request has been sent to HR
  [routeNames.hrApproval]: () => {
    return store.getters['application/isHRApprovalRequestSent'];
  },
  // Pass if the application has been marked as complete
  [routeNames.hrApprovalSent]: () => {
    return store.getters['application/isApplicationComplete'];
  },
  // Final page in the flow so it can not pass
  [routeNames.vehicleOrdered]: () => false,
  [routeNames.redirection]: () => false
};
